import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosError } from 'axios';
import { InsurancePolicyApi } from '@apis/InsurancePolicyApi';
import { InsurancePolicyUserApi } from '@apis/InsurancePolicyUserApi';
import { HealthClaim } from '@models/HealthClaim';
import { HealthClaimApi } from '@apis/HealthClaimApi';
import { SagaPayload } from '@utils/typescript';
import { history } from '@utils/history';
import { getResponseError } from '@utils/error';

import {
  policyFetch,
  PolicyFetchPayload,
  insurancePolicyUserFetch,
  InsurancePolicyUserFetchPayload,
  healthClaimCreate,
  HealthClaimCreatePayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';
import { InsurancePolicy } from '@models/InsurancePolicy';
import { InsurancePolicyUser } from '@models/InsurancePolicyUser';

function* handlePolicyFetch({ payload }: SagaPayload<PolicyFetchPayload>) {
  const state: StateUpdatePayload = { policy: null };
  try {
    state.policy = (yield call(InsurancePolicyApi.get, payload)) as InsurancePolicy;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleInsurancePolicyUserFetch({ payload }: SagaPayload<InsurancePolicyUserFetchPayload>) {
  const state: StateUpdatePayload = { insurancePolicyUser: null };
  try {
    state.insurancePolicyUser = (yield call(InsurancePolicyUserApi.get, payload)) as InsurancePolicyUser;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleHealthClaimCreate({ payload }: SagaPayload<HealthClaimCreatePayload>) {
  try {
    const state: StateUpdatePayload = { healthClaim: null };
    state.healthClaim = (yield call(HealthClaimApi.create, payload)) as HealthClaim;
    yield put(stateUpdate(state));
    history.navigate(`/user-dashboard/claim/HealthClaim/${state.healthClaim.id}`, {
      replace: true,
    });
  } catch (e) {
    const serverErrors = getResponseError(e as AxiosError).errors;
    const state: StateUpdatePayload = { serverErrors };
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(policyFetch, handlePolicyFetch);
  yield takeLatest(insurancePolicyUserFetch, handleInsurancePolicyUserFetch);
  yield takeLatest(healthClaimCreate, handleHealthClaimCreate);
}
